const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp", "image/gif"];
const ALLOWED_IMAGE_EXTENSIONS = /\.(jpe?g|png|webp|gif)$/i;
const MAX_IMAGE_SIZE_BYTES = 50 * 1024 * 1024;

export const normalizeRoutes = (data) => {
  if (Array.isArray(data)) return data;
  return data?.data || data?.routes || data?.items || [];
};

export const initialRouteForm = {
  title: "",
  total_distance_km: "",
  estimated_time: "",
  description: "",
};

export const mapRouteToForm = (route) => ({
  title: route?.title || route?.name || "",
  total_distance_km:
    route?.total_distance_km === 0 || route?.total_distance_km
      ? String(route.total_distance_km)
      : "",
  estimated_time: route?.estimated_time || "",
  description: route?.description || "",
});

export const validateRouteForm = (form, options = {}) => {
  const { imageFile = null } = options;
  const errors = {};

  if (!form.title?.trim()) {
    errors.title = "Title is required.";
  }

  const distance = Number(form.total_distance_km);
  if (
    form.total_distance_km === "" ||
    Number.isNaN(distance) ||
    !Number.isFinite(distance) ||
    distance <= 0
  ) {
    errors.total_distance_km = "Enter a valid distance in km.";
  }

  if (imageFile) {
    const type = String(imageFile.type || "").toLowerCase();
    const name = String(imageFile.name || "");
    const typeOk = ALLOWED_IMAGE_TYPES.includes(type);
    const extOk = ALLOWED_IMAGE_EXTENSIONS.test(name);

    if (!typeOk && !extOk) {
      errors.track_map_image = "Only JPEG, PNG, WEBP, GIF images are allowed.";
    } else if (imageFile.size > MAX_IMAGE_SIZE_BYTES) {
      errors.track_map_image = "Image must be 50MB or smaller.";
    }
  }

  return errors;
};

export const buildRoutePayload = (form, { imageFile = null, isEdit = false } = {}) => {
  const distance = Number(form.total_distance_km);

  const payload = {
    title: form.title.trim(),
    total_distance_km: distance,
  };

  if (form.estimated_time?.trim()) {
    payload.estimated_time = form.estimated_time.trim();
  }

  if (form.description?.trim()) {
    payload.description = form.description.trim();
  }

  // For now, treat track map image as optional. When present, send FormData.
  if (imageFile) {
    const formData = new FormData();
    formData.append("title", payload.title);
    formData.append("total_distance_km", String(payload.total_distance_km));
    if (payload.estimated_time) formData.append("estimated_time", payload.estimated_time);
    if (payload.description) formData.append("description", payload.description);
    formData.append("track_map_image", imageFile);
    return formData;
  }

  return payload;
};

